import { Prerequisite } from "@types";
import { FC } from "react";
import Search from "@svg/new-design/search";
import Link from "next/link";
interface Props {
  data: Prerequisite;
}

const PrerequisiteSearch: FC<Props> = ({ data }) => {
  if (!data.url) return null;
  return (
    <div className="px-4     border-fds-cart border rounded-8 h-14 items-center flex gap-2  w-full overflow-hidden">
      <Search className="text-fds-icon-secondary w-4     md:w-5    h-4     md:h-5" />
      <Link href={data.url || ""} prefetch={false} target="_blank">
        <p className="truncate title-sm md:title-md-demibold grow hover:text-fds-brand">
          {data.title}
        </p>
      </Link>
    </div>
  );
};

export default PrerequisiteSearch;
